/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_CaloriesInputs */

const en_ui_more_stats_calories = /** @type {(inputs: Ui_More_Stats_CaloriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calories`)
};

const de_ui_more_stats_calories = /** @type {(inputs: Ui_More_Stats_CaloriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalorien`)
};

/**
* | output |
* | --- |
* | "Calories" |
*
* @param {Ui_More_Stats_CaloriesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_calories = /** @type {((inputs?: Ui_More_Stats_CaloriesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_CaloriesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_calories(inputs)
	return de_ui_more_stats_calories(inputs)
});